let overlayElement = null
let messageElement = null

function getOrCreateOverlay() {
  if (overlayElement && document.body.contains(overlayElement)) return overlayElement

  overlayElement = document.createElement("div")
  overlayElement.className = "ai-overlay"
  overlayElement.innerHTML = `
    <div class="ai-overlay-content">
      <div class="ai-overlay-icon">
        <svg class="ai-overlay-bolt" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        <div class="ai-overlay-ring"></div>
        <div class="ai-overlay-ring ai-overlay-ring-delayed"></div>
      </div>
      <p class="ai-overlay-message">AI Generating...</p>
    </div>
  `

  messageElement = overlayElement.querySelector(".ai-overlay-message")
  document.body.appendChild(overlayElement)
  return overlayElement
}

export function showAiOverlay(message = "AI Generating...") {
  const overlay = getOrCreateOverlay()
  if (messageElement) messageElement.textContent = message
  requestAnimationFrame(() => {
    overlay.classList.add("ai-overlay-visible")
  })
}

export function hideAiOverlay() {
  if (!overlayElement) return
  overlayElement.classList.remove("ai-overlay-visible")
}
